/**
 * 1.1.78: 全局筛选（筛选模板）—— 当前选中的模板 id。
 *
 * 单独放一个小模块（而不是直接放 pinia store）是为了让 `services/http.ts` 能同步读到它：
 * 若 http 去 import store，会形成 http ← store ← http 的循环依赖。
 * 值持久化在 localStorage：刷新/切页后筛选依然生效。
 *
 * 后端读请求头 `x-filter-template`，把它与本人数据范围**取交集**后过滤所有 GET 响应
 * （只可能变窄，绝不放宽权限 —— 见 backend/src/modules/permissions/filter-template.service.ts）。
 */
const STORAGE_KEY = 'sku_filter_template';

export const FILTER_TEMPLATE_HEADER = 'x-filter-template';

function readStoredId(): number | null {
  try {
    const id = Number(window.localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null; // 隐私模式等 localStorage 不可用
  }
}

let activeId: number | null = readStoredId();

export function getActiveFilterTemplateId(): number | null {
  return activeId;
}

export function setActiveFilterTemplateId(id: number | null): void {
  activeId = id && Number(id) > 0 ? Number(id) : null;
  try {
    if (activeId) window.localStorage.setItem(STORAGE_KEY, String(activeId));
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* 忽略写入失败 */
  }
}
